import { render } from "./CarmineUse.vue?vue&type=template&id=3c6cb744&scoped=true"
import script from "./CarmineUse.vue?vue&type=script&lang=js"
export * from "./CarmineUse.vue?vue&type=script&lang=js"

import "./CarmineUse.vue?vue&type=style&index=0&id=3c6cb744&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6cb744"]])

export default __exports__